// extracted by mini-css-extract-plugin
module.exports = {"section":"_slug__section__BtaSY","header":"_slug__header__Cb3Jw","heading":"_slug__heading__WeBhV","published":"_slug__published__invUd","content":"_slug__content__wLMUT"};